import "typeface-roboto";
import "./src/styles/global.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import React from "react";
import { Providers } from "./src/components/layout";

export const wrapPageElement = ({ element, props }) => {
  return <Providers>{element}</Providers>;
};
